import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import Examination_navbar from "./Examination_navbar";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";

function ExamDataSO() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [SessionID, setSessionID] = useState(
    parseInt(localStorage.getItem("DefaultSession"), 10) || 0
  );
  const [resultCards, setResultCards] = useState([]);
  const [loadingCards, setLoadingCards] = useState(false);
  const [ResultCardID, setResultCardID] = useState(0);
  const [WingID, setWingID] = useState(0);
  const [ClassID, setClassID] = useState(0);
  const [SectionID, setSectionID] = useState(0);
  const [includeComponentTotals, setIncludeComponentTotals] = useState(false);
  const [masterSheetView, setMasterSheetView] = useState("Combined");
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    document.title = "Print Master Sheet";
  }, []);

  useEffect(() => {
    if (!SessionID) {
      setResultCards([]);
      return;
    }

    setLoadingCards(true);
    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetResultCards",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, SessionID },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setResultCards(response.data.ListofRecords || []);
        } else {
          setResultCards([]);
        }
        setLoadingCards(false);
      })
      .catch(() => {
        setResultCards([]);
        setLoadingCards(false);
      });
  }, [SessionID, AccessKey, UserID, MemberType]);

  useEffect(() => {
    if (!ResultCardID) {
      setSelectedCard(null);
      return;
    }
    const card = resultCards.find((c) => c.ID === ResultCardID);
    setSelectedCard(card || null);
  }, [ResultCardID, resultCards]);

  const buildQuery = () => {
    const params = new URLSearchParams({
      ID: String(ResultCardID),
      WingId: String(parseInt(WingID, 10) || 0),
      ClassId: String(parseInt(ClassID, 10) || 0),
      SectionId: String(parseInt(SectionID, 10) || 0),
    });
    return params.toString();
  };

  const canPrint = () => ResultCardID > 0 && parseInt(WingID, 10) > 0 && parseInt(ClassID, 10) > 0;

  const openPrint = (path, extraParams = "", requireScope = true) => {
    if (requireScope && !canPrint()) {
      toast.error("Select result card, wing, and class before printing.");
      return;
    }
    if (!ResultCardID) {
      toast.error("Select a result card.");
      return;
    }
    const query = buildQuery() + (extraParams ? `&${extraParams}` : "");
    window.open(`/ExaminationSystem/${path}?${query}`, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Examination_navbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/ExaminationSystem/ExaminationDashboard">Examinations</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Print Master Sheet
                  </li>
                </ol>
              </nav>
              <div className="page-title">Print Master Sheet</div>
              <p className="text-muted mb-0 small">
                Verify marks using the same rules as result publishing before you publish.
              </p>
            </div>
            <div className="col-md-4">
              <div className="page-right-actions d-flex gap-2 justify-content-md-end flex-wrap">
                <Link
                  to="/ExaminationSystem/PublishResultCard"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Publish Results
                  <i className="ri-upload-cloud-line"></i>
                </Link>
                <Link
                  to="/ExaminationSystem/ExaminationGuidelines"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Guidelines
                  <i className="ri-book-open-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="card mb-3">
                <div className="card-body">
                  <Form>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label>Session</label>
                        <select
                          className="form-select"
                          value={SessionID}
                          onChange={(e) => {
                            setSessionID(parseInt(e.target.value, 10) || 0);
                            setResultCardID(0);
                          }}
                        >
                          <option value="">Please Select</option>
                          <SessionsDropDown />
                        </select>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label>Result Card</label>
                        <select
                          className="form-select"
                          required
                          value={ResultCardID}
                          onChange={(e) =>
                            setResultCardID(parseInt(e.target.value, 10) || 0)
                          }
                        >
                          <option value="">Please Select</option>
                          {loadingCards ? (
                            <option disabled>Loading...</option>
                          ) : (
                            resultCards.map((item) => (
                              <option key={item.ID} value={item.ID}>
                                {item.ResultCard_Code} - {item.Title}
                              </option>
                            ))
                          )}
                        </select>
                        <div className="form-text">
                          Master sheets use this card&apos;s exams, weightage, and grade scale.
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label>Wing</label>
                        <select
                          className="form-select"
                          value={WingID}
                          onChange={(e) => {
                            setWingID(e.target.value);
                            setClassID(0);
                            setSectionID(0);
                          }}
                        >
                          <option value="0">Please Select</option>
                          <WingsDropDown selectedWingId={WingID} />
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label>Class</label>
                        <select
                          className="form-select"
                          value={ClassID}
                          onChange={(e) => {
                            setClassID(e.target.value);
                            setSectionID(0);
                          }}
                          disabled={!SessionID || parseInt(WingID, 10) <= 0}
                        >
                          <option value="0">Please Select</option>
                          {SessionID > 0 && parseInt(WingID, 10) > 0 && (
                            <ClassesDropDown
                              SessionID={SessionID}
                              WingID={WingID}
                              selectedClassId={ClassID}
                            />
                          )}
                        </select>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label>Section</label>
                        <select
                          className="form-select"
                          value={SectionID}
                          onChange={(e) => setSectionID(e.target.value)}
                          disabled={parseInt(ClassID, 10) <= 0}
                        >
                          <option value="0">All Sections</option>
                          {parseInt(ClassID, 10) > 0 && (
                            <SectionDropDown
                              ClassID={ClassID}
                              selectedSectionId={SectionID}
                            />
                          )}
                        </select>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>

              {selectedCard && (
                <div className="card mb-3 border-info">
                  <div className="card-body">
                    <h6 className="mb-2">Selected result card</h6>
                    <p className="mb-1">
                      <strong>{selectedCard.Title}</strong> ({selectedCard.ResultCard_Code})
                    </p>
                    <p className="mb-0 small text-muted">
                      Type: {selectedCard.Result_Type} &middot; Grade scale:{" "}
                      {selectedCard.Grade_Scale_Type || "Standard"} &middot; Components:{" "}
                      {selectedCard.ComponentCount || "—"}
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-4">
              <div className="card">
                <div className="card-body">
                  <h6 className="mb-3">Print options</h6>

                  <label className="form-label small mb-1">Master sheet layout</label>
                  <div className="form-check mb-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="masterSheetView"
                      id="masterSheetCombined"
                      checked={masterSheetView === "Combined"}
                      onChange={() => setMasterSheetView("Combined")}
                    />
                    <label className="form-check-label" htmlFor="masterSheetCombined">
                      Combined (summed for publish)
                    </label>
                  </div>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="masterSheetView"
                      id="masterSheetSeparate"
                      checked={masterSheetView === "Separate"}
                      onChange={() => setMasterSheetView("Separate")}
                    />
                    <label className="form-check-label" htmlFor="masterSheetSeparate">
                      Separate marks by source exam (same sheet)
                    </label>
                  </div>

                  <button
                    type="button"
                    className="button button-primary w-100 d-block mb-3"
                    disabled={!canPrint()}
                    onClick={() =>
                      openPrint(
                        "PrintMasterSheet",
                        `View=${masterSheetView === "Separate" ? "Separate" : "Combined"}`
                      )
                    }
                  >
                    {masterSheetView === "Separate"
                      ? "Master Sheet (Separate Marks)"
                      : "Composite Master Sheet"}
                  </button>
                  <p className="small text-muted mb-3">
                    {masterSheetView === "Separate"
                      ? "One sheet: marks per source exam in separate columns (max shown in header). Total Marks = sum of obtained marks; % and grade use the result-card formula."
                      : "Combined marks per subject (max in header). Total Marks = sum of obtained marks from all exams; % and grade match publish calculation."}
                  </p>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="componentTotalsCheck"
                      checked={includeComponentTotals}
                      onChange={(e) => setIncludeComponentTotals(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="componentTotalsCheck">
                      Include totals on component sheets
                    </label>
                  </div>

                  <button
                    type="button"
                    className="button button-primary w-100 d-block mb-3"
                    disabled={!canPrint()}
                    onClick={() =>
                      openPrint(
                        "PrintComponentMarksSheet",
                        `PrintTotal=${includeComponentTotals ? "Yes" : "No"}`
                      )
                    }
                  >
                    Component Marks Sheets
                  </button>
                  <p className="small text-muted mb-3">
                    One sheet per source exam on the result card for mark-entry verification.
                  </p>

                  <button
                    type="button"
                    className="button button-secondary w-100 d-block mb-3"
                    disabled={ResultCardID <= 0}
                    onClick={() => openPrint("PrintMarksCriteria", "", false)}
                  >
                    Marks Criteria &amp; Grade Scale
                  </button>

                  <hr />

                  <Link
                    to={
                      ResultCardID > 0
                        ? `/ExaminationSystem/PublishResultCard?ID=${ResultCardID}`
                        : "/ExaminationSystem/PublishResultCard"
                    }
                    className="button button-white w-100 d-block mb-2 text-center"
                    onClick={scrollToTop}
                  >
                    Go to Publish Results
                  </Link>
                  <button
                    type="button"
                    className="button button-white w-100 d-block mb-2"
                    disabled={!canPrint() || parseInt(SectionID, 10) <= 0}
                    onClick={() => {
                      if (parseInt(SectionID, 10) <= 0) {
                        toast.error("Select a section to print individual student result cards.");
                        return;
                      }
                      openPrint("PrintPublishedStudentResultCards");
                    }}
                  >
                    Print Student Result Cards
                  </button>
                  <p className="small text-muted mb-3">
                    A4 provisional intimation per student. Single-exam cards show that exam
                    only; composite cards also show the weighted final result. Requires
                    published results.
                  </p>
                  <button
                    type="button"
                    className="button button-white w-100 d-block mb-2"
                    disabled={!canPrint()}
                    onClick={() => {
                      if (!canPrint()) {
                        toast.error("Select result card, wing, and class before printing.");
                        return;
                      }
                      openPrint("PrintPublishedResultCardList", "", true);
                    }}
                  >
                    Print Class Summary List
                  </button>
                  <Link
                    to={
                      ResultCardID > 0
                        ? `/ExaminationSystem/PrintPublishedResultCard?ID=${ResultCardID}&Class_Id=${ClassID || 0}&Section_Id=${SectionID || 0}`
                        : "/ExaminationSystem/PrintPublishedResultCard"
                    }
                    className="button button-white w-100 d-block text-center"
                    onClick={scrollToTop}
                  >
                    View Published Results
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExamDataSO;
